import baseConfig from '@actr/config';
import { baseLog, LogFactory, useInitBaseLoggerData } from '@actr/logger';
import { YMUtils } from '@actr/logger/src/utils/ym';
import { translationManager } from '@actr/translator';
import { useState } from 'react';

export enum CommonAppLogs {
  RENDER,
  CHANGE_LOCALE,
  CHANGE_CURRENCY
}

const commonAppLog = baseLog.extend().bindEnum(CommonAppLogs);

function initCommonAppLogs() {
  return {
    isLogged: false,
    locale: translationManager.currentLocale,
    ymClientId: YMUtils.clientId
  };
}

export function useInitCommonAppLogs() {

  useState(() => {
    LogFactory.isLoggingEnable = baseConfig.app.trackingEnable;
  });

  useInitBaseLoggerData(initCommonAppLogs, commonAppLog, {});
}

export {
  commonAppLog
};
